import { useState } from 'react';
import '../styles/Login.css';
import { useNavigate } from 'react-router-dom';
import { sendAdminOtp } from '../pages/services/apiService';

const Login = () => {
    const [mobileNumber, setMobileNumber] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const handleSubmit = async (e) => {
        e.preventDefault();

        if (!mobileNumber) {
            setError("Mobile number is required");
            return;
        }

        if (!/^\d{10}$/.test(mobileNumber)) {
            setError("Enter valid 10 digit mobile number");
            return;
        }

        setError("");
        setLoading(true);

        try {
            await sendAdminOtp(mobileNumber);
            navigate("/otp", { state: { mobileNumber } });
        } catch (err) {
            const status = err.response?.status;
            const message = err.response?.data?.message || "Failed to send OTP. Please try again.";
            if (status === 404) {
                setError("Mobile number not registered as admin.");
            } else {
                setError(message);
            }
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className='login-page'>
            <div className="login-container">
                <div className="login-left">
                    <img src="/Logo/SkillVerse-Circle.png" alt="SkillVerse Logo" className="login-logo" />
                    <h1 className="login-title">Skillverse Admin Login</h1>
                </div>
                <div className="login-right">
                    <form className="form-group" onSubmit={handleSubmit}>
                        <label htmlFor="login-phone" className="login-label">Mobile Number</label>
                        <input
                            type="text"
                            className="login-input"
                            placeholder="Enter Your Mobile Number"
                            onChange={(e) =>
                                setMobileNumber(e.target.value.replace(/\D/g, ""))
                            }
                            value={mobileNumber}
                            maxLength={10} inputMode="numeric" />
                        {error && <p className="login-error">{error}</p>}
                        <button type='submit' className="login-btn" disabled={loading}>
                            {loading ? "Sending OTP..." : "Get OTP"}
                        </button>
                    </form>
                </div>
            </div>
        </div>
    );
};
export default Login;
